<template>
  <van-field v-model="input" rows="2" autosize type="textarea" @input="currentSel" :label="dModel.label"
    :placeholder="options.placeholder" :maxlength="options.maxlength" :rules="dModel.rules" />
</template>

<script>
  import formDesignMixins from './mixins/formDesignMixins'
  export default {
    name: "DesignTextarea",
    data() {
      return {
        input: "",
      };
    },
    mixins: [formDesignMixins],
    props: {
      value: {
        type: String,
      },
      options: {
        type: Object,
        default: function() {
          return {
            width: "100%", // 宽度
            maxLength: null,
            defaultValue: "",
            rows: 4,
            clearable: false,
            tooptip: '', // 提示
            hidden: false, // 是否隐藏，false显示，true隐藏
            disabled: false,
            placeholder: "请输入"
          }
        }
      }
    },
    methods: {
      currentSel: function(selVal) {
        this.$emit("input", selVal);
      },
    },
    watch: {
      value(nv) {
        this.input = nv;
      },
    },
    mounted: function() {
      this.input = this.value;
    },
  };
</script>

<style scoped="scoped">

</style>
